var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup50(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 77,
    height: 91,
    viewBox: "0 0 77 91",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_106",
    "data-name": "Rectangle 106",
    width: 77,
    height: 91,
    transform: "translate(0 0.013)",
    fill: "#ee8b3f"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_50",
    "data-name": "Group 50",
    transform: "translate(-0.47 -0.245)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_49",
    "data-name": "Group 49",
    transform: "translate(0.47 0.232)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M38.828,91.192a1.772,1.772,0,0,1-.337-.032A47.451,47.451,0,0,1,0,44.561V13.389a1.781,1.781,0,0,1,1.249-1.7L38.239.1a1.931,1.931,0,0,1,.589-.1h0a1.781,1.781,0,0,1,.587.1L76.406,11.689a1.782,1.782,0,0,1,1.249,1.7V44.561a47.453,47.453,0,0,1-38.491,46.6,1.772,1.772,0,0,1-.337.032M3.562,14.7V44.561A43.95,43.95,0,0,0,38.828,87.6,43.949,43.949,0,0,0,74.092,44.561V14.7L38.828,3.648Z",
    transform: "translate(-0.432 -0.178)",
    fill: "#ee8b3f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M84.854,129.22a1.794,1.794,0,0,1-.43-.052A37.533,37.533,0,0,1,56,92.8V68.953a1.78,1.78,0,0,1,1.248-1.7l27.072-8.482a1.784,1.784,0,0,1,1.065,0l27.073,8.482a1.78,1.78,0,0,1,1.248,1.7V92.8a37.53,37.53,0,0,1-4.362,17.526,1.781,1.781,0,0,1-3.147-1.67A33.945,33.945,0,0,0,110.144,92.8V70.262L84.853,62.338,59.562,70.262V92.8a33.856,33.856,0,0,0,25.291,32.8A33.6,33.6,0,0,0,96.3,120.127a1.781,1.781,0,1,1,2.112,2.868,37.167,37.167,0,0,1-13.131,6.173,1.791,1.791,0,0,1-.429.052",
    transform: "translate(-46.458 -48.416)",
    fill: "#ee8b3f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M136.58,202.03a1.774,1.774,0,0,1-1.259-.522l-11.927-11.927a1.78,1.78,0,0,1,0-2.518l6.045-6.045a1.781,1.781,0,0,1,2.519,0l4.622,4.622,11.092-11.093a1.782,1.782,0,0,1,2.519,0l6.045,6.045a1.78,1.78,0,0,1,0,2.518l-18.4,18.4a1.775,1.775,0,0,1-1.259.522m-9.408-13.708,9.408,9.408,15.878-15.878-3.527-3.526-11.092,11.093a1.782,1.782,0,0,1-2.518,0L130.7,184.8Z",
    transform: "translate(-101.419 -143.208)",
    fill: "#ee8b3f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M313,374.664a1.782,1.782,0,1,1,1.259-.522,1.79,1.79,0,0,1-1.259.522",
    transform: "translate(-256.22 -305.184)",
    fill: "#ee8b3f"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup50);
export default __webpack_public_path__ + "static/media/Group50.faad06477a36ac0d57b72b8556d36893.svg";
export { ForwardRef as ReactComponent };